import React, { useEffect } from 'react';

const NowLoading = ({ progressPercentage }) => {
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerHTML = `
            @keyframes spinner {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
            @keyframes blinking {
                0% {
                    opacity: 1;
                }
                100% {
                    opacity: 0;
                }
            }
        `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    return (
        <div
            className="spinner-body"
            style={{
                position:'fixed',
                WebkitBoxSizing: 'border-box',
                boxSizing: 'border-box',
                backgroundColor: 'rgba(47, 46, 46, 0.51)',
                height: '120vh',  // ← 100% → 100vh へ
                width: '100vw',
                top: '0',
                left:'0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                overflowY: 'auto', // ← 縦スクロール可能に
            }}
        >
            <div
                className="spinner-container"
                style={{
                    width: '150px',
                    height: '150px',
                    position: 'relative',
                    margin: '30px auto',
                    overflow: 'hidden',
                    
                }}
            >
                <div
                    className="spinner"
                    style={{
                        position: 'absolute',
                        width: 'calc(100% - 9.9px)',
                        height: 'calc(100% - 9.9px)',
                        border: '5px solid transparent',
                        borderTopColor: '#0288D1',
                        borderRadius: '50%',
                        animation: 'spinner 5s cubic-bezier(0.17, 0.49, 0.76, 0.96) infinite'
                    }}
                >
                    <div className="spinner"
                    style={{
                        position: 'absolute',
                        width: 'calc(100% - 9.9px)',
                        height: 'calc(100% - 9.9px)',
                        border: '5px solid transparent',
                        borderTopColor: '#0288D1',
                        borderRadius: '50%',
                        animation: 'spinner 5s cubic-bezier(0.17, 0.49, 0.76, 0.96) infinite'
                    }}
                >
                        <div className="spinner"
                    style={{
                        position: 'absolute',
                        width: 'calc(100% - 9.9px)',
                        height: 'calc(100% - 9.9px)',
                        border: '5px solid transparent',
                        borderTopColor: '#0288D1',
                        borderRadius: '50%',
                        animation: 'spinner 5s cubic-bezier(0.17, 0.49, 0.76, 0.96) infinite'
                    }}
                >
                            <div className="spinner"
                    style={{
                        position: 'absolute',
                        width: 'calc(100% - 9.9px)',
                        height: 'calc(100% - 9.9px)',
                        border: '5px solid transparent',
                        borderTopColor: '#0288D1',
                        borderRadius: '50%',
                        animation: 'spinner 5s cubic-bezier(0.17, 0.49, 0.76, 0.96) infinite'
                    }}
                >

                            </div>
                        </div>
                    </div>
                </div>
                <div className="progress-container" style={{ marginTop: '20px' }}>
                    <progress max="100" value={progressPercentage} id="progress"></progress>
                </div>
                <p className="progress-text" style={{ marginTop: '10px', textAlign: 'center', color: 'darksalmon' }}>
                    {progressPercentage}%
                </p>
                <h2 className='loading_h2'
                    style={{
                        animation: 'blinking 1.5s ease infinite alternate',
                        color: 'darksalmon'
                    }}
                
                >Now loading...</h2>
            </div>
        </div>
    );
};

export default NowLoading;





//使用例　使いたいコンポネントに書く



//const [progressPercentage, setProgressPercentage] = useState(0);



// const response = await axios.post(process.env.REACT_APP_UPLOAD_URL, formData, {
//     headers: {
//         'Content-Type': 'multipart/form-data'
//     },
//     onUploadProgress: function (progressEvent) {
//         let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//         setProgressPercentage(percentCompleted);
//     }
// });




//使いたいコンポネントのretrunに以下を入れる
// {loading && <NowLoading progressPercentage={progressPercentage} />}
